import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-2xl font-bold mb-4">Mehdi Richa</h3>
            <p className="text-slate-400 mb-6 leading-relaxed max-w-md">
              Formateur polyvalent et auditeur qualité dans le Vaucluse. 
              J'accompagne les entreprises, organismes de formation et collectivités 
              dans leurs démarches qualité et leurs besoins en formation.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-5 h-5 text-blue-400" />
              <span>Basé à Avignon, Vaucluse (France)</span>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-accueil"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link 
                  to="/audit-qualite-vaucluse" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-audit"
                >
                  Audit qualité
                </Link>
              </li>
              <li>
                <Link 
                  to="/formateur-polyvalent-vaucluse" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-formations"
                >
                  Formations
                </Link>
              </li>
              <li>
                <Link 
                  to="/a-propos" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-apropos"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-blog"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:0620968980" 
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5 text-blue-400" />
                  06 20 96 89 80
                </a>
              </li>
              <li>
                <a 
                  href="mailto:mehdi.richa.formation@gmail.com" 
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5 text-blue-400" />
                  mehdi.richa.formation@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Mehdi Richa – Formateur & Auditeur Qualité. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4">
            <Link 
              to="/mentions-legales" 
              className="text-slate-500 hover:text-white text-sm transition-colors"
              data-testid="footer-link-mentions"
            >
              Mentions légales
            </Link>
            <span className="text-slate-700">|</span>
            <p className="text-slate-500 text-sm">
              Vaucluse (Avignon, Carpentras, Orange)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
